import { Badge, Card, CardContent, Text } from '@/design-system/components/ui';
import useConfirm from '@/hooks/useConfirm';

import { usePendingTriggersStore } from '../../stores/pendingTriggersStore';
import { PendingTriggerItem } from './PendingTriggerItem';

interface Props {
  triggerErrors?: Record<string, string>;
}

export const PendingTriggersSummary = ({ triggerErrors = {} }: Props) => {
  const pendingTriggers = usePendingTriggersStore((s) => s.pendingTriggers);
  const removeTrigger = usePendingTriggersStore((s) => s.removeTrigger);
  const setEditingTriggerId = usePendingTriggersStore((s) => s.setEditingTriggerId);

  const [ConfirmationDialog, confirm] = useConfirm();

  const handleEdit = (id: string) => {
    setEditingTriggerId(id);
  };

  const handleDelete = async (id: string) => {
    const trigger = pendingTriggers.find((t) => t.id === id);
    const confirmed = await confirm({
      title: 'Delete trigger',
      message: `Are you sure you want to delete "${trigger?.triggerOption.title}"?`,
    });

    if (confirmed) {
      removeTrigger(id);
    }
  };

  return (
    <>
      {ConfirmationDialog}
      <Card id="pending-triggers-summary" className="tw:bg-transparent tw:shadow-none tw:border-none">
        <CardContent>
          <div className="tw:flex tw:flex-col tw:gap-4">
            <div className="tw:flex tw:flex-row tw:justify-between tw:items-center">
              <Text variant="title-sm">Triggers to be created</Text>
              <Badge size="sm">
                {`${pendingTriggers.length} ${pendingTriggers.length === 1 ? 'trigger' : 'triggers'}`}
              </Badge>
            </div>
            {pendingTriggers.map((trigger) => (
              <PendingTriggerItem
                key={trigger.id}
                trigger={trigger}
                onEdit={handleEdit}
                onDelete={handleDelete}
                error={triggerErrors[trigger.id]}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </>
  );
};
